/**
 * A global namespace for `scroll` event.
 * @type {string}
 */
const scrollEvent = 'scroll';
export default scrollEvent;
